module.exports = __webpack_public_path__ + "static/img/console.285e1f59.svg";